export enum ButtonVariant {
  PRIMARY = "primary",
  PRIMARY_ALT = "primary-alt",
  SECONDARY = "secondary",
  WARN = "warn",
  TEXT = "text",
  TEXT_ALT = "text-alt"
}
export enum ButtonValue {
  SMALL = 25,
  LARGE = 50,
  EXTRA_LARGE = 75
}

export enum ButtonSize {
  MEDIUM = "medium",
  LARGE = "large",
  SMALL = "small"
}

export enum ButtonType {
  BUTTON = "button",
  SUBMIT = "submit",
  RESET = "reset",
  LOADER = "loader"
}

export enum DropdownPlacement {
  BOTTOM_RIGHT = "bottom-right",
  BOTTOM_LEFT = "bottom-left"
}
